import { TaskBasic, TaskRef } from '@/tracker/types';

/** Задачи колонки под заголовками родителей — как на доске Яндекс Трекера. Порядок — как отдал поиск */
export const groupByParent = (issues: TaskBasic[]) => {
  const groups = new Map<string | null, { parent: TaskRef | null; issues: TaskBasic[] }>();

  issues.forEach((issue) => {
    const key = issue.parent?.key ?? null;
    const group = groups.get(key) ?? { parent: issue.parent, issues: [] };

    group.issues.push(issue);
    groups.set(key, group);
  });

  return [...groups.values()];
};
